/* eslint-disable camelcase */
import React, { useState } from 'react'

import Contact from '../Contact';
import Bucket from '../Bucket';
import Jaula from '../Jaula';
import EntryPoints from '../EntryPoints';
import TemplateStudio from '../TemplateStudio';
import Campaigns from '../Campaigns';

const Home = () => {
    const [tabSelected, setTabSelected] = useState("Home")
    return (
        <div>
            <div className="flex justify-start">
                <div className="vh-100 fixed">
                    <bds-navbar background-color="surface-3" justify-content="space-between" orientation="vertical">
                        <bds-navbar-content>
                            <bds-button-icon
                                variant="secondary"
                                icon="home"
                                onClick={() => {
                                    setTabSelected("Home")
                                }}
                            />
                            <bds-button-icon
                                variant="secondary"
                                icon="user-default"
                                onClick={() => {
                                    setTabSelected("Contact")
                                }}
                            />
                            <bds-button-icon
                                variant="secondary"
                                icon="dynamic-content"
                                onClick={() => {
                                    setTabSelected("Bucket")
                                }}
                            />
                            <bds-button-icon
                                variant="secondary"
                                icon="link"
                                onClick={() => {
                                    setTabSelected("EntryPoint")
                                }}
                            />
                            <bds-button-icon
                                variant="secondary"
                                icon="false"
                                onClick={() => {
                                    setTabSelected("Jaula")
                                }}
                            />
                            <bds-button-icon
                                variant="secondary"
                                icon="paste"
                                onClick={() => {
                                    setTabSelected("TemplateStudio")
                                }}
                            />
                            <bds-button-icon
                                variant="secondary"
                                icon="primeiro-acesso"
                                onClick={() => {
                                    setTabSelected("Campaigns")
                                }}
                            />
                        </bds-navbar-content>
                        <bds-navbar-content>
                            <bds-button-icon variant="secondary" icon="settings-general"/>
                        </bds-navbar-content>
                    </bds-navbar>
                </div>
                <div className="ml5 w-100 overflow-auto">
                    {tabSelected === "Home" &&
                        <div className="">
                                <div className="pa5 vh-100">
                                    <div className="pb5 pl3">
                                        <bds-typo variant="fs-40" tag="h1">
                                            Myde Tools
                                        </bds-typo>
                                        <bds-divider styleType="solid" orientation="horizontal" color="divider-1"></bds-divider>
                                    </div>
                                    <div className="flex justify-around">
                                        <div className="mr5">
                                            <bds-card
                                                clickable="true"
                                                width='400px'
                                                onClick={() => {
                                                    setTabSelected("Contact")
                                                }}
                                            >
                                                <bds-card-header align='center'>
                                                    <bds-grid direction="column">
                                                        <bds-card-title text="Variaveis de contato e contexto"></bds-card-title>
                                                    </bds-grid>
                                                </bds-card-header>
                                                <bds-card-body>
                                                    <bds-grid direction="column" xxs="12" gap="1" justify-content="center" align-items="center">
                                                        <bds-icon type="icon" size="brand" name="user-default"></bds-icon>
                                                    </bds-grid>
                                                </bds-card-body>
                                                <bds-card-footer align='center'>
                                                    <bds-typo bold="bold">Variaveis</bds-typo>
                                                </bds-card-footer>
                                            </bds-card>
                                        </div>
                                        <div className="mr5">
                                            <bds-card
                                                clickable="true"
                                                width='400px'
                                                onClick={() => {
                                                    setTabSelected("Bucket")
                                                }}
                                            >
                                                <bds-card-header align='center'>
                                                    <bds-grid direction="column">
                                                        <bds-card-title text="Gestão de bucket"></bds-card-title>
                                                    </bds-grid>
                                                </bds-card-header>
                                                <bds-card-body>
                                                    <bds-grid direction="column" xxs="12" gap="1" justify-content="center" align-items="center">
                                                        <bds-icon type="icon" size="brand" name="dynamic-content"></bds-icon>
                                                    </bds-grid>
                                                </bds-card-body>
                                                <bds-card-footer align='center'>
                                                    <bds-typo bold="bold">Bucket</bds-typo>
                                                </bds-card-footer>
                                            </bds-card>
                                        </div>
                                        <div className="mr5">
                                            <bds-card
                                                clickable="true"
                                                width='400px'
                                                onClick={() => {
                                                    setTabSelected("EntryPoint")
                                                }}
                                            >
                                                <bds-card-header align='center'>
                                                    <bds-grid direction="column">
                                                        <bds-card-title text="Gestão de direcionamentos"></bds-card-title>
                                                    </bds-grid>
                                                </bds-card-header>
                                                <bds-card-body>
                                                    <bds-grid direction="column" xxs="12" gap="1" justify-content="center" align-items="center">
                                                        <bds-icon type="icon" size="brand" name="link"></bds-icon>
                                                    </bds-grid>
                                                </bds-card-body>
                                                <bds-card-footer align='center'>
                                                    <bds-typo bold="bold">EntryPoint</bds-typo>
                                                </bds-card-footer>
                                            </bds-card>
                                        </div>
                                    </div>
                                    <div className="flex justify-around mt5">
                                        <div className="mr5">
                                            <bds-card
                                                clickable="true"
                                                width='400px'
                                                onClick={() => {
                                                    setTabSelected("Jaula")
                                                }}
                                            >
                                                <bds-card-header align='center'>
                                                    <bds-grid direction="column">
                                                        <bds-card-title text="Bloqueio de usuarios"></bds-card-title>
                                                    </bds-grid>
                                                </bds-card-header>
                                                <bds-card-body>
                                                    <bds-grid direction="column" xxs="12" gap="1" justify-content="center" align-items="center">
                                                        <bds-icon type="icon" size="brand" name="false"></bds-icon>
                                                    </bds-grid>
                                                </bds-card-body>
                                                <bds-card-footer align='center'>
                                                    <bds-typo bold="bold">Jaula</bds-typo>
                                                </bds-card-footer>
                                            </bds-card>
                                        </div>
                                        <div className="mr5">
                                            <bds-card
                                                clickable="true"
                                                width='400px'
                                                onClick={() => {
                                                    setTabSelected("TemplateStudio")
                                                }}
                                            >
                                                <bds-card-header align='center'>
                                                    <bds-grid direction="column">
                                                        <bds-card-title text="Criação de templates"></bds-card-title>
                                                    </bds-grid>
                                                </bds-card-header>
                                                <bds-card-body>
                                                    <bds-grid direction="column" xxs="12" gap="1" justify-content="center" align-items="center">
                                                        <bds-icon type="icon" size="brand" name="paste"></bds-icon>
                                                    </bds-grid>
                                                </bds-card-body>
                                                <bds-card-footer align='center'>
                                                    <bds-typo bold="bold">TemplateStudio</bds-typo>
                                                </bds-card-footer>
                                            </bds-card>
                                        </div>
                                        <div className="mr5">
                                            <bds-card
                                                clickable="true"
                                                width='400px'
                                                onClick={() => {
                                                    setTabSelected("Campaigns")
                                                }}
                                            >
                                                <bds-card-header align='center'>
                                                    <bds-grid direction="column">
                                                        <bds-card-title text="Gestão de campanhas ativas"></bds-card-title>
                                                    </bds-grid>
                                                </bds-card-header>
                                                <bds-card-body>
                                                    <bds-grid direction="column" xxs="12" gap="1" justify-content="center" align-items="center">
                                                        <bds-icon type="icon" size="brand" name="primeiro-acesso"></bds-icon>
                                                    </bds-grid>
                                                </bds-card-body>
                                                <bds-card-footer align='center'>
                                                    <bds-typo bold="bold">Campaigns</bds-typo>
                                                </bds-card-footer>
                                            </bds-card>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    }
                    {tabSelected === "Contact" &&
                        <Contact />
                    }
                    {tabSelected === "Bucket" &&
                        <Bucket />
                    }
                    {tabSelected === "EntryPoint" &&
                        <EntryPoints />
                    }
                    {tabSelected === "Jaula" &&
                        <Jaula />
                    }
                    {tabSelected === "TemplateStudio" &&
                        <TemplateStudio />
                    }
                    {tabSelected === "Campaigns" &&
                        <Campaigns />
                    }
                </div>
            </div>
        </div>
    );
};

Home.propTypes = {};

export default Home;
